/* Marquee behavior: pause off-screen and allow keyboard/click pause. */
(function () {
  'use strict';

  function initMarquee(bar) {
    if (!bar || bar.dataset.marqueeInitialized === 'true') return;

    var track = bar.querySelector('[data-marquee-track]');
    if (!track) return;

    bar.dataset.marqueeInitialized = 'true';
    bar.setAttribute('tabindex', '0');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Store announcements. Press Enter or Space to pause or resume.');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          track.classList.toggle('is-paused', !entry.isIntersecting);
        });
      }, { threshold: 0 });

      observer.observe(bar);
    }

    function toggle() {
      track.classList.toggle('is-paused');
    }

    bar.addEventListener('click', toggle);
    bar.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-marquee-announcement]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
